module.exports = __webpack_public_path__ + "img/faq1.395aa0ec.webp";